export default __webpack_public_path__ + "static/team01-7d97d4656982ceea9357e03a09584fc4.png";